import React, { useEffect } from 'react'
import Select from 'react-select'
import { useForm } from "react-hook-form";
import FormGroup from 'components/Form/FormGroup'
import FormImage from 'components/Form/FormImage'
import Spinner from 'react-bootstrap/Spinner'
import * as Yup from 'yup'
import { DevTool } from "react-hook-form-devtools";
import * as moment from 'moment-timezone'
import "pages/partnerInformation.scss";
import { ErrorSharp } from '@material-ui/icons';

export const symbolFromCurrency = (currency) => {
    if (currency === "EUR") {
        return "€"
    } else if (currency === "GBP") {
        return "£"
    }
    return "$"
}

const currencyOptions = [
    {
        label: "USD",
        value: "USD"
    },
    {
        label: "AUD",
        value: "AUD"
    },
    {
        label: "CAD",
        value: "CAD"
    },
    {
        label: "EUR",
        value: "EUR"
    },
    {
        label: "GBP",
        value: "GBP"
    }
]

function PartnerPaymentsForm(props) {

    const { user } = props;
    const { handleFormSubmission } = props;

    console.log("USER: ", user)

    const { register, control, handleSubmit, setValue, getValues, formState, errors, watch } = useForm({
        mode: 'onBlur',
        validationSchema: Yup.object({
            absorbFees: Yup.boolean(),
            currency: Yup.string().required("please select a currency"),
            chargeSystemTax: Yup.boolean(),
            systemTaxName: Yup.string().when('chargeSystemTax', {
                is: true,
                then: Yup.string().required("Must include name for tax rate")
            }),
            systemTaxRate: Yup.number().when('chargeSystemTax', {
                is: true,
                then: Yup.number().positive("Tax rate must be a positive number")
            })
        }),
        defaultValues: {
            absorbFees: user.instructorProfile?.absorbFees ?? false,
            currency: user.instructorProfile?.currency ?? "USD",
            chargeSystemTax: user.instructorProfile?.chargeSystemTax ?? false,
            systemTaxName: user.instructorProfile?.systemTax?.name ?? "",
            systemTaxRate: user.instructorProfile?.systemTax?.rate ?? 0
        }
    });

    const { chargeSystemTax } = watch()

    const { dirty } = formState;

    const onSubmit = (data) => {

        if (handleFormSubmission) {
            var dataUpdate = {}
            dataUpdate.instructorProfile = {
                ...user.instructorProfile,
                absorbFees: data.absorbFees,
                currency: data.currency,
                chargeSystemTax: data.chargeSystemTax,
                systemTax: {
                    name: data.chargeSystemTax ? data.systemTaxName : "",
                    rate: data.chargeSystemTax ? data.systemTaxRate : 0
                }
            }

            handleFormSubmission(dataUpdate)
        }
    }

    return (<>
        <form className="partnerInformationForm" onSubmit={handleSubmit(onSubmit)}>

            <section className="pt-5">

                <FormGroup
                    fullSize
                    select
                    options={currencyOptions}
                    type="text"
                    name="currency"
                    label="Currency"
                    sublabel="Students will be charged in this currenct"
                    placeholder="Select one..."
                    control={control}
                    setValue={setValue}
                    getValues={getValues}
                />

                <FormGroup
                    fullSize
                    type="checkbox"
                    name="absorbFees"
                    label="Absorb Fees"
                    placeholder="Sutra collects a hosting fee to keep our service up and running! If you check this box, they will be deducted from your revenue, rather than passed on to your students. Note: This does not apply to subscription purchases to minimize the probability of credit card declines. Therefore, we recommend you increase the pricing of your subscriptions to account for these fees."
                    register={register}
                />


            </section>





            <section >

                <FormGroup
                    fullSize
                    type="checkbox"
                    name="chargeSystemTax"
                    label="Charge System-wide tax"
                    placeholder="By checking this box you will begin to charge your customers a system-wide tax for any of your offerings."
                    register={register}
                />

                <div className={chargeSystemTax ? "" : "d-none"}>

                    <FormGroup
                        fullSize
                        type="text"
                        name="systemTaxName"
                        label="System Tax Name"
                        sublabel="This tax name will show at checkout"
                        register={register}
                        error={errors.firstName}
                    />

                    <FormGroup
                        fullSize
                        type="percentage"
                        name="systemTaxRate"
                        error={errors.systemTaxRate}
                        label="Tax Rate"
                        sublabel="This tax rate will apply to all products and services"
                        placeholder="0"
                        register={register}
                    />

                </div>

            </section>


            <div className="row">
                <div className="col-md-12 d-flex justify-content-end">
                    <button disabled={!dirty || props.isSaving} type="submit" className="btn btn-primary">
                        {props.isSaving && (
                            <Spinner
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden={true}
                                className="ml-2"
                            >
                                <span className="sr-only">Saving...</span>
                            </Spinner>
                        )}
                        Save changes
                    </button>
                </div>
            </div>


        </form>
        <DevTool control={control} />
    </>)
}

export default PartnerPaymentsForm;